import { HttpClient, HttpEventType, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { catchError, throwError } from 'rxjs';
import { MessageModalComponent } from '../components/message-modal/message-modal.component';

/**
 * @author Brayan Cataño
 * @summary This interceptor handles 403 errors (Forbidden) globally. When a 403 error is encountered, it displays an alert to the user indicating that they do not have the necessary permissions to perform the action.
 */
export const missingPermissionsInterceptor: HttpInterceptorFn = (req, next) => {
  const _dialog = inject(MatDialog);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 403) {
        _dialog.closeAll();
        _dialog.open(MessageModalComponent, { data: { message: $localize`You do not have the required permissions to perform this action. If you believe this is an error, please contact technical support.`, title: $localize`Permission denied` }, width: '400px', disableClose: true });
      }
      return throwError(() => error);
    })
  );


};